function CalculatorStep({
  stepContent,
  inputLabels,
  calculatorSettings,
  calculatorValues,
  setCalculatorValues,
  handleNextClick,
  userSelections,
}) {
  return (
    <Step
      stepId={`calculator`}
      stepContent={stepContent}
      handleNextClick={handleNextClick}
      userSelections={userSelections}
    >
      <Calculator
        inputLabels={inputLabels}
        calculatorSettings={calculatorSettings}
        calculatorValues={calculatorValues}
        setCalculatorValues={setCalculatorValues}
      />
    </Step>
  );
}
